import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { TemplateSaveForm } from "./TemplateSaveForm";
import { BoardTemplate } from "../../../../lib/api/boardTemplates";

interface BoardSaveTemplateModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSaveSuccess: (template: BoardTemplate) => void;
    currentChartConfig: any[];
}

export const BoardSaveTemplateModal: React.FC<BoardSaveTemplateModalProps> = ({
    isOpen,
    onClose,
    onSaveSuccess,
    currentChartConfig,
}) => {
    const { t } = useTranslation("common");

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 modal-backdrop transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 text-left align-middle shadow-xl transition-all">
                                <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900">
                                    <Dialog.Title as="h3" className="text-lg font-bold text-neutral-900 dark:text-neutral-100">
                                        {t("boards.saveAsTemplate") || "Save as Template"}
                                    </Dialog.Title>
                                    <button
                                        onClick={onClose}
                                        className="text-neutral-400 hover:text-neutral-500 dark:text-neutral-500 dark:hover:text-neutral-300 transition-colors p-1 rounded-md hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                    >
                                        <span className="w-5 h-5" style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_350784a5.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_350784a5.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
                                    </button>
                                </div>

                                <div className="max-h-[70vh] flex flex-col">
                                    <TemplateSaveForm
                                        onSave={onSaveSuccess}
                                        onCancel={onClose}
                                        chartConfig={currentChartConfig}
                                    />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
